const { formatText } = require('core/i18n').i18n;

const FLOW_STEPS = {
    STEP_1: 1,
    STEP_2: 2,
    STEP_3: 3,
    STEP_4: 4,
    STEP_5: 5
};

const API_FLOW_STEPS = {
    STEP_1: 'STEP_1',
    STEP_2: 'STEP_2',
    STEP_3: 'STEP_3',
    STEP_4: 'STEP_4',
    STEP_5: 'STEP_5'
};

const DISCLAIMER_CONTEXT = {
    POSTAL_CODE: 'POSTAL_CODE',
    ADDRESS: 'ADDRESS',
}

const PAYMENT_TYPE = {
    ANNUAL: 'ANNUAL',
    BIANNUAL: 'BIANNUAL',
    QUARTERLY: 'QUARTERLY'
};

const INSURANCE_STATE = {
    SIMULATION: 'SIMULATION',
    INVALID: 'INVALID',
}

const MAX_DAYS_INSURANCE_INIT = 90;
const MAX_DAYS_INSURANCE_ASSOCIATED = 60;
const DATE_FORMAT_ES = 'DD MMMM YYYY';
const DATE_FORMAT_EN = 'MMMM DD YYYY';

const LENGTH_POSTAL_CODE = 5;
const PROPERTY_CHARACTER = {
    OWNER: 'OWNER',
    TENANT: 'TENANT',
};

const PROPERTY_USAGE = {
    PRINCIPAL: 'PRINCIPAL',
    SECONDARY: 'SECONDARY',
    RENT: 'RENT',
};

const PROPERTY_USAGE_RELATED = {
    PRIMERA_VIVIENDA: PROPERTY_USAGE.PRINCIPAL,
    SEGUNDA_VIVIENDA: PROPERTY_USAGE.SECONDARY,
};

const PROPERTY_TYPE = {
    PENTHOUSE: 'PENTHOUSE',
    APARTMENT: 'APARTMENT',
    GROUND_FLOOR: 'GROUND_FLOOR',
    CHALET: 'CHALET',
    TOWNHOUSE: 'TOWNHOUSE'
};

const SIZE_SLIDER_CONFIG = {
    MIN: 24,
    MAX: 1000,
    DEFAULT: 24,
    UNIT: 'm2'
};

const CONTINENT_SLIDER_CONFIG = {
    MIN: 6000,
    MAX: 1200000,
    MIN_TENANT: 6000,
    MAX_TENANT: 10000
};

const CONTENT_SLIDER_CONFIG = {
    MIN: 1000,
    MAX: 150000,
    MAX_RENT: 5000,
    MAX_PRINCIPAL_CC: 300000,
};

const DOCUMENT_TYPES = {
    BUDGET: 'BUDGET',
    INFORMATIVE_NOTE: 'INFORMATIVE_NOTE',
    PRODUCT_INFORMATION: 'PRODUCT_INFORMATION',
    POLICY: 'POLICY',
    DOCUMENT_CONDITIONS: 'DOCUMENT_CONDITIONS',
    PRE_POLICY: 'PRE_POLICY',
    HOME_ZC: 'HOME_ZC'
};

const WIZARD_REQUEST_RESPONSE_OPTIONS = {
    ERROR: 'ERROR',
    NO_PROCESS: 'NO_PROCESS',
    SUCCESS: 'SUCCESS',
    IS_FETCHING: 'IS_FETCHING',
    FALSE: 'FALSE'
};

const WIZARD_REQUEST_RESPONSE_ERROR_CODES = {
    ALREADY_INSURED_ADDRESS: '8390',
}

const VALUE_TYPES = {
    CHECK: 'CHECK',
    DOGS: 'DOGS',
    MONEY: 'MONEY',
    PERCENTAGE: 'PERCENTAGE',
    NUMBER: 'NUMBER'
};

const PLANS = {
    BASIC: 'BASIC',
    MEDIUM: 'MEDIUM',
    HIGH: 'HIGH'
};

const COVERAGES = {
    AESTHETIC_DAMAGE: 'AESTHETIC_DAMAGE',
    BROKEN_GLASS: 'BROKEN_GLASS',
    CIVIL_LIABILITY: 'CIVIL_LIABILITY',
    DANGEROUS_DOGS_NUMBER: 'DANGEROUS_DOGS_NUMBER',
    ELECTRICAL_DAMAGE: 'ELECTRICAL_DAMAGE',
    FIRES: 'FIRES',
    IMPAIRMENTS_HOUSING: 'IMPAIRMENTS_HOUSING',
    LEGAL_DEFENSE: 'LEGAL_DEFENSE',
    STOLE: 'STOLE',
    THEFT_MONEY: 'THEFT_MONEY',
    WATER_DAMAGE: 'WATER_DAMAGE'
};

const COVERAGES_CONFIGURABLE = {
    AESTHETIC_DAMAGE: 'AESTHETIC_DAMAGE',
    CIVIL_LIABILITY: 'CIVIL_LIABILITY',
    ELECTRICAL_DAMAGE: 'ELECTRICAL_DAMAGE',
    STOLE: 'STOLE',
    THEFT_MONEY: 'THEFT_MONEY',
    IMPAIRMENTS_HOUSING: 'IMPAIRMENTS_HOUSING',
    DANGEROUS_DOGS_NUMBER: 'DANGEROUS_DOGS_NUMBER',
};

const TARGET_COUNTRY = 'ES';

const TYPEOFROADS = {
    OTHERS: 'OTHERS',
    UNKNOWN: 'UNKNOWN'
};

const CC_INSURANCE_SEND_MAIL_CODES = {
    HOME_INSURANCE_REQUEST_RELATED: "THIC_01",
    HOME_INSURANCE_REQUEST: "THINC_01"
};

const NA = 'N/A';

const INVALID_DATE = 'Invalid date';

const HOME_INSURANCE_CONFIRMATION_ID = 170;
const HOME_INSURANCE_RELATED_CONFIRMATION_ID = 181;
const CONTENT_TYPE_PDF = 'application/pdf';

const WORKFLOW_STATE = [
    'GENERANDO_OV',
    'ESPERA_DOC_FIRMA',
    'GESTION_FECHA_FIRMA',
    'ESPERA_ACTA_NOTARIO',
    'PROV_FONDOS',
    'PEND_MMPP',
    'PEND_SALDO',
    'PEND_FIRMA',
    'ANULADO',
];

const wizardSimulationName = {
    INSURANCE_SUMMARY: 'insuranceSummary',
    INSURANCE_SUMMARY_RELATED: 'insuranceSummaryRelated',
    INSURANCE_SUMMARY_RNC: 'insuranceSummaryRnc',
};

const SPECIAL_COVERAGES_MODAL = {
    DOGS_INCLUSION_YES: 'S',
    DOGS_INCLUSION_NO: 'N',
    INTEGER_OR_EMPTY: /^(-?((\d)|(\d*)))?$/,
    DOGS_INCLUSION: 'DOGS_INCLUSION',
    MIN: 1,
    MAX: 99,
    CIVIL_RESPONSABILITY_OPTIONS: {
        '150000': {
            label: 150000,
            value: 'C'
        },
        '250000': {
            label: 250000,
            value: 'E'
        },
        '300000': {
            label: 300000,
            value: 'G'
        },
        '450000': {
            label: 450000,
            value: 'I'
        },
        '600000': {
            label: 600000,
            value: 'K'
        },
        '750000': {
            label: 750000,
            value: 'M'
        }
    }
};

const TOPBAR_DEFAULT_HEIGHT = 92;
const PRODUCT_BANNERS_MARGIN_TOP = 30;

const COVERAGES_NAMES = {
    [COVERAGES.ELECTRICAL_DAMAGE]: 'electricalDamage',
    [COVERAGES.AESTHETIC_DAMAGE]: 'aestheticDamage',
    [COVERAGES.CIVIL_LIABILITY]: 'civilResponsability',
    [SPECIAL_COVERAGES_MODAL.DOGS_INCLUSION]: 'dangerousDogs',
    [COVERAGES.DANGEROUS_DOGS_NUMBER]: 'dangerousDogsNumber',
    [COVERAGES.IMPAIRMENTS_HOUSING]: 'flawImport',
    [COVERAGES.THEFT_MONEY]: 'metallicImport',
};
const getPropertyTypeOptions = () => {
    return [
        { label: formatText('insuranceRequestHome-step2Floor'), value: PROPERTY_TYPE.APARTMENT },
        { label: formatText('insuranceRequestHome-step2Attic'), value: PROPERTY_TYPE.PENTHOUSE },
        { label: formatText('insuranceRequestHome-step2Chalet'), value: PROPERTY_TYPE.CHALET },
        { label: formatText('insuranceRequestHome-step2TownHouse'), value: PROPERTY_TYPE.TOWNHOUSE }
    ]
};

const text = () => {
    return {
        DISCOUNT: formatText('insuranceRequestHome-step4paymentSavings'),
        DISCOUNT_RELATED: formatText('insuranceRequestHome-step4paymentSavingsRelated'),
        FIRST_IMPORT: {
            BIANNUAL: formatText('insuranceRequestHome-step4BiannualFirstInstallment'),
            QUARTERLY: formatText('insuranceRequestHome-step4QuarterlyFirstInstallment')
        },
        SUCCESSIVE_IMPORT: {
            BIANNUAL: formatText('insuranceRequestHome-step4BiannualSecondInstallment'),
            QUARTERLY: formatText('insuranceRequestHome-step4QuarterlySuccessiveInstallments')
        },
        SUMMARY: {
            FIRST_IMPORT: {
                BIANNUAL: formatText('insuranceRequestHome-summaryBiannualFirstInstallment'),
                QUARTERLY: formatText('insuranceRequestHome-summaryQuarterlyFirstInstallment')
            },
            SUCCESSIVE_IMPORT: {
                BIANNUAL: formatText('insuranceRequestHome-summaryBiannualSecondInstallment'),
                QUARTERLY: formatText('insuranceRequestHome-summaryQuarterlySuccessiveInstallments')
            }
        }
    }
}

module.exports = {
    API_FLOW_STEPS,
    CC_INSURANCE_SEND_MAIL_CODES,
    CONTENT_SLIDER_CONFIG,
    CONTENT_TYPE_PDF,
    CONTINENT_SLIDER_CONFIG,
    COVERAGES_CONFIGURABLE,
    COVERAGES_NAMES,
    COVERAGES,
    DATE_FORMAT_EN,
    DATE_FORMAT_ES,
    DISCLAIMER_CONTEXT,
    DOCUMENT_TYPES,
    FLOW_STEPS,
    getPropertyTypeOptions,
    HOME_INSURANCE_CONFIRMATION_ID,
    HOME_INSURANCE_RELATED_CONFIRMATION_ID,
    INSURANCE_STATE,
    INVALID_DATE,
    LENGTH_POSTAL_CODE,
    MAX_DAYS_INSURANCE_ASSOCIATED,
    MAX_DAYS_INSURANCE_INIT,
    NA,
    PAYMENT_TYPE,
    PLANS,
    PRODUCT_BANNERS_MARGIN_TOP,
    PROPERTY_CHARACTER,
    PROPERTY_TYPE,
    PROPERTY_USAGE_RELATED,
    PROPERTY_USAGE,
    SIZE_SLIDER_CONFIG,
    SPECIAL_COVERAGES_MODAL,
    TARGET_COUNTRY,
    text,
    TOPBAR_DEFAULT_HEIGHT,
    TYPEOFROADS,
    VALUE_TYPES,
    WIZARD_REQUEST_RESPONSE_ERROR_CODES,
    WIZARD_REQUEST_RESPONSE_OPTIONS,
    wizardSimulationName,
    WORKFLOW_STATE,
};
